import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { fetchData } from '../../Services/apiService.js';
import { apiUrl } from '../../config/api.js';
import './CoursePages.css';

const CourseInfo = () => {
  const { id, lectID } = useParams();
  const [event, setEvent] = useState(null);
  const [offering, setOffering] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData(apiUrl(`ByID/Courses/${lectID}`))
      .then(async (data) => {
        const selectedEvent = data?.[0];
        setEvent(selectedEvent || null);
        if (selectedEvent?.CourseType) {
          const offeringData = await fetchData(apiUrl(`ByType/Offerings/${selectedEvent.CourseType}`));
          setOffering(offeringData?.[0] || null);
        }
      })
      .catch((error) => console.error('Error fetching course information:', error))
      .finally(() => setLoading(false));
  }, [lectID]);

  if (loading) return <main className="course-page-state">Loading course…</main>;
  if (!event || !offering) return <main className="course-page-state">Course not found.</main>;

  return (
    <main className="course-page">
      <header className="course-page__hero course-page__hero--compact">
        <div className="container course-page__container">
          <Link to={`/course/${id}`} className="course-page__back">← Back to program</Link>
          <span className="course-page__level">{offering.course_type}</span>
          <h1>{offering.title}</h1>
        </div>
      </header>

      <div className="container course-page__container course-info">
        <section className="course-info__session">
          <span className="course-page__eyebrow">Selected session</span>
          <h2>{event?.CourseTitle || 'Loading session details…'}</h2>
          {event && <>
            <p className="course-info__description">{event.CourseDesc}</p>
            <div className="course-info__facts">
              <div><span>Date</span><strong>{event.CourseDate}</strong></div>
              <div><span>Time</span><strong>{event.Time}</strong></div>
              <div><span>Mentor</span><strong>{event.CourseBy}</strong></div>
              <div><span>Location</span><strong>{event.CourseLocation}</strong></div>
              <div><span>Language</span><strong>{event.Language}</strong></div>
              <div><span>Fee</span><strong>{event.Fees || 'Free'}</strong></div>
            </div>
            <Link to={`/ApplyCourse/${id}/${lectID}`} className="course-info__apply">Reserve your seat <span aria-hidden="true">→</span></Link>
          </>}
        </section>

        <section className="course-info__learn">
          <span className="course-page__eyebrow">What you’ll learn</span>
          <h2>{offering.subtitle}</h2>
          <p>{offering.overview}</p>
          <ul className="course-page__checklist">{offering.highlights?.map((item, index) => <li key={index}>{item}</li>)}</ul>
          {offering.sections?.map((section, index) => (
            <article className="course-page__topic" key={`${section.title}-${index}`}><h3>{section.title}</h3>{section.items?.length > 0 && <ul>{section.items.map((item, itemIndex) => <li key={itemIndex}>{item}</li>)}</ul>}</article>
          ))}
        </section>
      </div>
    </main>
  );
};

export { CourseInfo };
